"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24",
    fill: "#004864"
  }, props), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "12.5",
    y: "16.02",
    width: "4.5",
    height: "3"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "7",
    y: "16.02",
    width: "4.5",
    height: "3"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "12.5",
    y: "12.02",
    width: "4.5",
    height: "3"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "7",
    y: "12.02",
    width: "4.5",
    height: "3"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0,23.52a.5.5,0,0,0,.5.5h23a.5.5,0,0,0,.5-.5V8H0ZM2.5,16a.5.5,0,0,1,0-1H6V12H2.5a.5.5,0,0,1,0-1H6V9.52a.5.5,0,1,1,1,0V11h4.5V9.52a.5.5,0,1,1,1,0V11H17V9.52a.5.5,0,1,1,1,0V11h3.5a.5.5,0,0,1,0,1H18v3h3.5a.5.5,0,0,1,0,1H18v3h3.5a.5.5,0,0,1,0,1H18v1.5a.5.5,0,0,1-1,0V20H12.5v1.5a.5.5,0,0,1-1,0V20H7v1.5a.5.5,0,0,1-1,0V20H2.5a.5.5,0,0,1,0-1H6V16Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.5,2H20V.52a.5.5,0,0,0-.5-.5h-3a.5.5,0,0,0-.5.5V2H8V.52A.5.5,0,0,0,7.5,0h-3a.5.5,0,0,0-.5.5V2H.5a.5.5,0,0,0-.5.5V7H24V2.52A.5.5,0,0,0,23.5,2ZM7,4H5V1H7ZM19,4H17V1h2Z"
  }));
};

exports["default"] = _default;